<div class="border-card border-0 px-4 py-1 scroll-container" ref="view_entity_type">
  <div class="d-flex justify-content-between align-items-center mb-1 me-4">
    <NavigationBackButton/>
    <div class="d-flex align-items-center gap-3">
        <span class="project-badge text-xs p-0 d-inline-flex align-items-center">
            <i class='bx bxs-bookmark-alt fs-5 me-1 text-primary-blue'></i>
            Entity Type / <span class="fw-bold p-1"> {{entity_type_name}}</span>
        </span>
        <span class="project-badge text-xs p-0 d-inline-flex align-items-center">
            <i class='bi bi-file-earmark-text fs-5 me-1 text-primary-blue'></i>
            Form / <span class="fw-bold p-1"> {{form_name}}</span>
        </span>
    </div>
  </div>
  <div class="card-header card-header-primary card-nav-tabs border rounded-lg mt-3 shadow">
        <div class="nav-tabs-navigation">
          <div class="nav-tabs-wrapper">
              <ul class="nav nav-tabs" data-tabs="tabs">
                  <li class="border rounded-lg me-2 nav-item"  :class="{ active: sub_active_tab === 'Main Sections', inactive: sub_active_tab !== 'Main Sections' ,'active-tab': active_tab === tab }"
                  @click="set_sub_active_tab('Main Sections')">
                      <a class="text-white text-decoration-none text-xs nav-link" href="#profile" data-toggle="tab">
                       Sections
                      </a>
                  </li>
                  <li class="nav-item d-none"
                      :class="{ active: sub_active_tab === 'Sections', 'active-tab': active_tab === tab }"
                      @click="set_sub_active_tab('Sections')">
                      <a class="text-dark text-decoration-none text-xs nav-link" href="#profile" data-toggle="tab">
                          Sections
                      </a>
                  </li>

                  <li class="border rounded-lg me-2 nav-item " :class="{ active: sub_active_tab === 'Create Questions' , inactive: sub_active_tab !== 'Create Questions' }" @click="set_sub_active_tab('Create Questions')">
                    <a class="text-white text-decoration-none text-xs nav-link" href="#profile" data-toggle="tab">
                      Create Questions
                    </a>
                </li>
                <li class="border rounded-lg me-2 nav-item " :class="{ active: sub_active_tab === 'Verify Questions' , inactive: sub_active_tab !== 'Verify Questions' }" @click="set_sub_active_tab('Verify Questions')">
                    <a class="text-white text-decoration-none text-xs nav-link" href="#profile" data-toggle="tab">
                      Verify Questions
                    </a>
                </li>
                <li class="border rounded-lg me-2 nav-item " :class="{ active: sub_active_tab === 'Preview Form' , inactive: sub_active_tab !== 'Preview Form'}" @click="set_sub_active_tab('Preview Form')">
                  <a class="text-white text-decoration-none text-xs nav-link" href="#profile" data-toggle="tab">
                    Preview Form
                  </a>
                </li>
                <li
                  v-if="is_onboarding_checklist_form"
                  class="border rounded-lg me-2 nav-item"
                  :class="{ active: sub_active_tab === 'Onboarding Checklist', inactive: sub_active_tab !== 'Onboarding Checklist' }"
                  @click="set_sub_active_tab('Onboarding Checklist')"
                >
                  <a class="text-white text-decoration-none text-xs nav-link" href="#profile" data-toggle="tab">
                    Onboarding Checklist
                  </a>
                </li>

              </ul>
              <hr class="text-white"/>
          </div>
       </div>
  </div>
  <div class="card shadow rounded-lg mt-2">
      <div class="card-body">
        <div v-if="sub_active_tab === 'Main Sections'">
          <CreateMainSections/>
        </div>
        <div v-if="sub_active_tab === 'Sections'">
          <CreateSections/>
        </div>
 
        <div v-if="sub_active_tab === 'Create Questions'">
          <CreateQuestions/>
        </div>

        <div v-if="sub_active_tab === 'Verify Questions'">
          <ConfigureVerificationQuestions/>
        </div>
 
        <div v-if="sub_active_tab === 'Preview Form'">
          <div class="entity-scrollable-container p-4">
            <PreviewForm/>
          </div>
          
        </div>
        <div v-if="sub_active_tab === 'Onboarding Checklist' && is_onboarding_checklist_form">
          <div class="entity-scrollable-container p-4">
            <ComplianceChecklist/>
          </div>
        </div>

    </div>
  </div>
</div>